/* ============================================================
   HDHeat — 全站行为埋点（2026-10-12 甲）
   目的：补齐转化漏斗（PDP 浏览 / 加购 / 进结账）+ 变体维度 + 来源(UTM / 站外引荐)。
   设计：**零侵入** —— 不改任何 section，靠 theme.liquid 一行引入 + 运行时拦截。
   🔴 全部包 try/catch：任何异常都不得影响页面既有脚本。
   上报：POST https://bridge.highdeep.net/heat/event
         { kind:'view'|'add_to_cart'|'checkout_started', productId, workId, variantId, src, path }
   ============================================================ */
(function () {
  var BRIDGE = 'https://bridge.highdeep.net';
  /* 原生 fetch 引用：必须在 patch 之前捕获，否则埋点自己会被拦（自噬） */
  var NATIVE_FETCH = (typeof window.fetch === 'function') ? window.fetch.bind(window) : null;

  /* ---------- 来源（UTM / 站外引荐）：本会话首访记一次 ---------- */
  function srcOf() {
    try {
      var k = 'hd_src', v = '';
      try { v = sessionStorage.getItem(k) || ''; } catch (e) {}
      if (v) return v;
      try {
        var q = new URLSearchParams(location.search || '');
        var s = q.get('utm_source') || '', m = q.get('utm_medium') || '', c = q.get('utm_campaign') || '';
        if (s || m || c) {
          v = 'utm:' + [s, m, c].filter(Boolean).join('/');
        } else {
          var host = '';
          try { host = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
          v = (host && host !== location.hostname) ? ('ref:' + host) : 'direct';
        }
      } catch (e) { v = 'direct'; }
      v = String(v).slice(0, 120);
      try { sessionStorage.setItem(k, v); } catch (e) {}
      return v;
    } catch (e) { return ''; }
  }

  var _sent = {};
  function post(kind, d, once) {
    try {
      if (!NATIVE_FETCH) return;
      d = d || {};
      var key = kind + '|' + (d.productId || 0) + '|' + (d.variantId || '');
      if (once) { if (_sent[key]) return; _sent[key] = 1; }
      var body = JSON.stringify({
        kind: String(kind),
        productId: d.productId || 0,
        workId: d.workId || '',
        variantId: d.variantId || '',
        src: srcOf(),
        path: (location.pathname || '') + (location.search || '')
      });
      NATIVE_FETCH(BRIDGE + '/heat/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (e) {}
  }

  /* 暴露（可选增强；其它脚本不依赖它也能工作） */
  try { window.HDHeat = { track: function (k, d) { post(k, d, false); }, src: srcOf }; } catch (e) {}

  /* ---------- ① PDP 浏览（补齐漏斗第一环 —— 原先 PDP 完全没有埋点） ---------- */
  try {
    var p = location.pathname || '';
    if (p.indexOf('/products/') === 0) {
      var pid = 0, wid = '';
      var m = /^\/products\/custom-(\d+)-([A-Za-z0-9_-]+)/.exec(p);
      if (m) { pid = parseInt(m[1], 10) || 0; wid = m[2]; }
      else if (window.PF_ID) { pid = parseInt(window.PF_ID, 10) || 0; }
      if (pid) post('view', { productId: pid, workId: wid }, true);
    }
  } catch (e) {}

  /* ---------- ② 从 FormData / URLSearchParams / 字符串体里取 variant id ---------- */
  function vidOf(init) {
    try {
      var b = init && init.body;
      if (b && typeof b.get === 'function') {
        var v0 = b.get('id');
        if (v0) return String(v0).slice(0, 32);
      }
      if (typeof b === 'string') {
        var mm = /(?:^|&)id=([^&]+)/.exec(b);
        if (mm) return decodeURIComponent(mm[1]).slice(0, 32);
      }
    } catch (e) {}
    return '';
  }

  /* ---------- ③ 拦截 fetch：加购(/cart/add.js) 与 进结账(/checkout) ---------- */
  try {
    if (NATIVE_FETCH) {
      window.fetch = function (input, init) {
        try {
          var u = (typeof input === 'string') ? input : ((input && input.url) || '');
          if (/\/cart\/add(\.js)?(\?|$)/.test(u)) {
            post('add_to_cart', { productId: window.PF_ID || 0, variantId: vidOf(init) }, false);
          } else if (/\/checkout(\?|$)/.test(u)) {
            post('checkout_started', { productId: window.PF_ID || 0 }, true);
          }
        } catch (e) {}
        return NATIVE_FETCH.apply(null, arguments);
      };
    }
  } catch (e) {}

  /* ---------- ④ 点击委托：结账按钮 / 站内结账链接（跳转式结账不经过 fetch） ---------- */
  try {
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (!t || typeof t.closest !== 'function') return;
        if (t.closest('[name="checkout"], a[href*="/checkout"], button[formaction*="checkout"]')) {
          post('checkout_started', { productId: window.PF_ID || 0 }, true);
        }
      } catch (e) {}
    }, true);
  } catch (e) {}
})();
